// extracted by mini-css-extract-plugin
export default {"pageContainer":"PrivacyPages_pageContainer__PIUf5","pageContainerInner":"PrivacyPages_pageContainerInner__lUhcG"};